/**
 * Nav icon map: resolves the icon name strings the backend stores in
 * `page_capabilities.icon` and `nav_sections.icon` to Lucide components.
 *
 * Shared by the V2 sidebar and the navigation layout admin so the two cannot
 * drift. Every name a backend migration assigns must have an entry here, or
 * the item silently shows the Home fallback (TRUS-721: Provider directory
 * used `Building2` and Telehealth used `Video`, and both rendered as Home).
 */
import {
  Activity, AlertTriangle, ArrowLeftRight, Award, BarChart3, BookOpen, Bot,
  Brain, Briefcase, Building, Building2, Calendar, CheckCircle, ClipboardCheck,
  ClipboardList, Clock, CreditCard, Database, DollarSign, Eye, FilePlus,
  FileSearch, FileSpreadsheet, FileText, Flame, FolderKanban, FolderOpen,
  FormInput, Gift, GitBranch, Globe, GraduationCap, Headphones, Heart,
  HeartPulse, History, Home, Inbox, Languages, LayoutDashboard, Library, LifeBuoy,
  ListChecks, ListOrdered, ListTodo, Lock, Mail, MapPin, Megaphone,
  MessageSquare, MoreHorizontal, Network, Phone, PieChart, Play, Radio, Receipt,
  Rocket, Search, Send, Settings, Share2, Shield, ShieldCheck, Sliders,
  SlidersHorizontal, Sparkles, Store, Target, TrendingUp, User, UserCheck,
  UserCircle, UserCog, UserPlus, Users, Users2, Video, Workflow, Zap,
} from 'lucide-react'
import type { LucideIcon } from 'lucide-react'

export const NAV_ICON_MAP: Record<string, LucideIcon> = {
  Activity, AlertTriangle, ArrowLeftRight, Award, BarChart3, BookOpen, Bot,
  Brain, Briefcase, Building, Building2, Calendar, CheckCircle, ClipboardCheck,
  ClipboardList, Clock, CreditCard, Database, DollarSign, Eye, FilePlus,
  FileSearch, FileSpreadsheet, FileText, Flame, FolderKanban, FolderOpen,
  FormInput, Gift, GitBranch, Globe, GraduationCap, Headphones, Heart,
  HeartPulse, History, Home, Inbox, Languages, LayoutDashboard, Library, LifeBuoy,
  ListChecks, ListOrdered, ListTodo, Lock, Mail, MapPin, Megaphone,
  MessageSquare, MoreHorizontal, Network, Phone, PieChart, Play, Radio, Receipt,
  Rocket, Search, Send, Settings, Share2, Shield, ShieldCheck, Sliders,
  SlidersHorizontal, Sparkles, Store, Target, TrendingUp, User, UserCheck,
  UserCircle, UserCog, UserPlus, Users, Users2, Video, Workflow, Zap,
  // Lucide's alias for Video; telehealth.sessions stores this spelling.
  VideoIcon: Video,
}

export function resolveNavIcon(iconName?: string | null): LucideIcon {
  return (iconName && NAV_ICON_MAP[iconName]) || Home
}
